import { createTheme } from '@mui/material'
import { DefaultTheme } from 'styled-components'
import DefaultLight from '../Guigotv/Ligth'

const theme: DefaultTheme = createTheme({
  ...DefaultLight,
  backgroundColor: '#fafafa',
  textColor: 'black',
  imgForm: '/LogoProviders/verofamilia.png',
  colors: {
    primary: { main: '#ec3e75', hover: '#ec3e75' },
    secondary: { main: '#ffd31b', hover: '#ffd31b' },
    ternary: { main: '#f5f5f5', hover: '#f5f5f5' },
  },
  typography: {
    allVariants: {
      fontFamily: 'BwSeidoRound',
    },
    h3: {
      padding: '10px',
    },
    fontFamily: 'BwSeidoRound',
    fontSize: 16,
  },
  components: {
    MuiLink: {
      defaultProps: {
        fontFamily: 'BwSeidoRound',
      },
    },
  },
})

export default theme
